import axios from 'axios'
import {
  GET_SITE_LICENCE,
  SITE_SETTINGS_LOADING,
  GET_DECRYPTED_LICENCE,
  GET_SETTINGS_ERROR,
  SET_SITE_LICENCE,
  GET_AUTH_ALERT,
  SET_AUTH_ALERT,
  GET_PUBLIC_STATUS,
} from './types'
import { ToastsStore } from 'react-toasts'
import { resetErrors } from './errorsActions'

//GET SITE Licence SETTINGS
export const getSiteLicence = () => dispatch => {
  dispatch(setSiteSettingsLoading())
  dispatch(resetErrors)

  axios
    .get('/api/settings/site-licence')
    .then(res => {
      dispatch({
        type: GET_SITE_LICENCE,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({ type: GET_SETTINGS_ERROR, payload: err.response.data })
    })
}

//SET QLIK SENSE SERVER DETAILS (SAVE TO DATABASE)
export const setSiteLicence = qsServerData => dispatch => {
  dispatch(setSiteSettingsLoading())
  dispatch(resetErrors)

  axios
    .post('/api/settings/site-licence', qsServerData)
    .then(res => {
      dispatch(getSiteLicence())
      dispatch({
        type: SET_SITE_LICENCE,
        payload: res.data,
      })
      ToastsStore.success('Site Licence updated successfully')
    })
    .catch(err => {
      dispatch({
        type: GET_SETTINGS_ERROR,
        payload: err.response.data,
      })
    })
}

export const getDecryptedSiteLicence = () => dispatch => {
  dispatch(setSiteSettingsLoading())
  dispatch(resetErrors)

  axios
    .get('/api/settings/decrypt-licence')
    .then(res => {
      dispatch({
        type: GET_DECRYPTED_LICENCE,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_SETTINGS_ERROR,
        payload: err.response.data,
      })
    })
}

export const getAuthAlert = () => dispatch => {
  dispatch(setSiteSettingsLoading())
  dispatch(resetErrors)
  axios
    .get('/api/settings/alert')
    .then(res => {
      dispatch({
        type: GET_AUTH_ALERT,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_SETTINGS_ERROR,
        payload: err.response.data,
      })
    })
}

export const setAuthAlert = alert => dispatch => {
  dispatch(setSiteSettingsLoading())
  dispatch(resetErrors)
  axios
    .post('/api/settings/alert', alert)
    .then(res => {
      dispatch({
        type: SET_AUTH_ALERT,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_SETTINGS_ERROR,
        payload: err.response.data,
      })
    })
}

export const getPublicStatus = () => dispatch => {
  // dispatch(setSiteSettingsLoading())
  axios
    .get('/api/settings/publicAccessStatus')
    .then(res => {
      // dispatch({type : GET_PUBLIC_STATUS , payload: true});

      dispatch({ type: GET_PUBLIC_STATUS, payload: res.data })
    })
    .catch(err => {
      console.log(err)
      err.response &&
        dispatch({
          type: GET_SETTINGS_ERROR,
          payload: err.response.data,
        })
    })
}

export const setPublicStatus = status => dispatch => {
  dispatch(setSiteSettingsLoading())
  axios
    .post('/api/settings/publicAccessStatus', status)
    .then(res => {
      dispatch({ type: GET_PUBLIC_STATUS, payload: res.data.publicAccess })
      ToastsStore.success('Public status updated successfully')
    })
    .catch(err => {
      err.response &&
        dispatch({
          type: GET_SETTINGS_ERROR,
          payload: err.response.data,
        })
    })
}

//QLIK SENSE SERVER LOADING
export const setSiteSettingsLoading = () => {
  return {
    type: SITE_SETTINGS_LOADING,
  }
}
